export const YOUTUBE_REGEX =
  /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
export const YOUTUBE_SHORT_REGEX = /(?:youtube\.com\/shorts\/|youtu\.be\/)([A-Za-z0-9_-]{11})/;
export const YOUTUBE_LIVE_REGEX = /(?:youtube\.com\/live\/|youtu\.be\/)([A-Za-z0-9_-]{11})/;
export const VIMEO_REGEX =
  /vimeo\.com\/(?:channels\/[\w]+\/|groups\/[^/]+\/videos\/|album\/\d+\/video\/|video\/|)(\d+)/;

export function getVideoType(url: string) {
  if (!url) return undefined;
  if (YOUTUBE_REGEX.test(url)) return 'youtube';
  if (YOUTUBE_SHORT_REGEX.test(url)) return 'youtube';
  if (YOUTUBE_LIVE_REGEX.test(url)) return 'youtube';
  if (VIMEO_REGEX.test(url)) return 'vimeo';

  return undefined;
}

export function getYoutubeEmbedUrl(youtubeUrl: string) {
  const match = youtubeUrl.match(YOUTUBE_REGEX);
  if (match) return `https://www.youtube.com/embed/${match[1]}?rel=0`;
  const shortMatch = youtubeUrl.match(YOUTUBE_SHORT_REGEX);
  if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}?rel=0`;
  const liveMatch = youtubeUrl.match(YOUTUBE_LIVE_REGEX);
  if (liveMatch) return `https://www.youtube.com/embed/${liveMatch[1]}?rel=0`;

  return undefined;
}

export function getVimeoEmbedUrl(vimeoUrl: string) {
  const match = vimeoUrl.match(VIMEO_REGEX);
  if (match) return `https://player.vimeo.com/video/${match[1]}`;

  return undefined;
}

export function getEmbedUrl(url: string) {
  const videoType = getVideoType(url);
  if (videoType === 'youtube') return getYoutubeEmbedUrl(url);
  if (videoType === 'vimeo') return getVimeoEmbedUrl(url);

  return undefined;
}
